import React, { Component } from 'react'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'

import { Avatar } from '@driftt/tide-core'

import * as style from './style'

import DEFAULT_AVATAR from '!svg-inline?removeTags=true!images/live/default-company-logo.svg'

export default class CompanyAvatar extends Component {
  render() {
    const {
      className,
      companyName,
      logoUrl,
    } = this.props

    if (!logoUrl) {
      return (
        <div className={cx(style.placeholderAvatar, className)}>
          <IconSVG src={DEFAULT_AVATAR}/>
        </div>
      )
    }

    return (
      <div className={cx(style.companyAvatar, className)}>
        <Avatar company={{ name: companyName, logo: logoUrl }} type="company" size="small"/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Company/Header/CompanyAvatar/index.js